import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import PieChart from '../core/PieChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "pie-chart-example"
    }}>{`Pie chart example`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <h2 {...{
      "id": "pie-chart-with-standart-legend"
    }}>{`Pie chart with standart legend`}</h2>
    <Playground __position={0} __code={'<PieChart\n  noAnimation\n  colors={[\'red\', \'yellow\', \'green\', \'blue\']}\n  legendPosition=\"inside\"\n  radius=\"75%\"\n  toolboxTooltip={{ saveAsImage: \'saving\' }}\n  title=\"pie chart\"\n  resultFormatType=\"percent\"\n  labelFontColor=\"black\"\n  tooltipTitle=\"title\"\n  center={[\'50%\', \'50%\']}\n  data={[\n    { name: \'Ruim\', value: 25 },\n    { name: \'Satisfatório\', value: 10 },\n    { name: \'Bom\', value: 45 },\n    { name: \'Ótimo\', value: 10 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      PieChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <PieChart noAnimation colors={['red', 'yellow', 'green', 'blue']} legendPosition='inside' radius='75%' toolboxTooltip={{
        saveAsImage: 'saving'
      }} title='pie chart' resultFormatType='percent' labelFontColor='black' tooltipTitle='title' center={['50%', '50%']} data={[{
        name: 'Ruim',
        value: 25
      }, {
        name: 'Satisfatório',
        value: 10
      }, {
        name: 'Bom',
        value: 45
      }, {
        name: 'Ótimo',
        value: 10
      }]} mdxType="PieChart" />
    </Playground>
    <h2 {...{
      "id": "pie-chart-with-scrollable-legend"
    }}>{`Pie chart with scrollable legend`}</h2>
    <Playground __position={1} __code={'<div style={{ width: \'300px\' }}>\n  <PieChart\n    legendType=\"scroll\"\n    colors={[\'blue\', \'green\', \'red\', \'purple\', \'black\']}\n    legendPosition=\"inside\"\n    radius=\"75%\"\n    toolboxTooltip={{ saveAsImage: \'saving\' }}\n    title=\"pie chart\"\n    center={[\'50%\', \'50%\']}\n    data={[\n      { name: \'Sem treinamento\', value: 25 },\n      { name: \'Não utilizava EPI\', value: 10 },\n      { name: \'Não conhecia as normas\', value: 45 },\n      { name: \'Defeito de equipamento\', value: 10 },\n      { name: \'Improvisação\', value: 90 },\n    ]}\n  />\n</div>'} __scope={{
      props,
      DefaultLayout,
      PieChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div style={{
        width: '300px'
      }}>
        <PieChart legendType="scroll" colors={['blue', 'green', 'red', 'purple', 'black']} legendPosition='inside' radius='75%' toolboxTooltip={{
          saveAsImage: 'saving'
        }} title='pie chart' center={['50%', '50%']} data={[{
          name: "Sem treinamento",
          value: 25
        }, {
          name: "Não utilizava EPI",
          value: 10
        }, {
          name: "Não conhecia as normas",
          value: 45
        }, {
          name: "Defeito de equipamento",
          value: 10
        }, {
          name: "Improvisação",
          value: 90
        }]} mdxType="PieChart" />
    </div>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      